/**
 * @description 公用接口
 */
import { IS_CW } from "@/config/config";
import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { stringify } from "qs";
import { ExceedBudgetWarningRequest, GetCodeRequest, LoginRequest, LoginRequestSwitch, GetAllSubCompanyListRequest, AgentLonginOem } from "./commonLimit";
const { ac, cs, budgetCloud, qy } = baseUrl;

class Basic {
  /**
   * @api{property} 官网登录
   * @param params 登录参数
   * @returns {Promise}
   */
  //  * @api{property} 官网登录
  LoginNonTrace(data: LoginRequest | LoginRequestSwitch) {
    return axios.post(`${ac}/connect/token`, stringify(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Real-IP": sessionStorage.getItem("cityjson_cip"),
      },
      ...IS_CW,
    });
  }
  /** 获取登录验证码 */
  getVerificationCode(params: GetCodeRequest) {
    return axios.get(`${ac}/Common/GetVerificationCode`, { params });
  }
  /**
   * 获取公司列表
   */
  getAgentUserId(agentUserId: string) {
    return axios.get(`${cs}/CompanyFinancial/GetCompanysByAgentUserId/${agentUserId}`);
  }
  /**
   * 根据公司id获取所有账套信息
   */
  GetCustomerList(params: { companyid: string; operateType: number }) {
    return axios.get(`${qy}/FinancialCloud/GetAgentCustomerList`, { params });
  }
  /**
   * 获取超预算预警列表
   */
  exceedBudgetWarning(params: ExceedBudgetWarningRequest) {
    return axios.get(`${budgetCloud}/HomeIndex/ExceedBudgetWarning`, { params });
  }
  /**
   * 获取首页上面待我审批、抄送我的、超预算预警计数器信息及明细
   */
  getPageUpCounters() {
    return axios.get(`${cs}/Counter/GetPageUpCounters`);
  }
  /**
   * 获取企业号对应各个模块的计数器
   */
  getCompanyCounter() {
    return axios.get(`${cs}/Counter/GetCompanyCounter`);
  }
  /**
   *  企业版权限
   */
  GetRoleAuthorityTree() {
    return axios.get(`${qy}/Authority/GetRoleAuthorityTree`);
  }
  /**
   * 财务大管家 修改第一次登录
   */
  editAgentUser(isFirst = false) {
    return axios.put(`${cs}/UserFinancialManage/EditAgentUser?isFirstLogin=${isFirst}`);
  }
  /**
   * 获取当前登录用户所有可见企业及其账套(树形结构)
   */
  GetAllSubCompanyList(params: GetAllSubCompanyListRequest) {
    return axios.get(`${cs}/FinancialCloud/GetAllSubCompanyList`, { params });
  }
  /**
   * 当前登录代理商是否开启oem
   */
  apiAgentLonginOem(params: AgentLonginOem) {
    return axios.get(`${cs}/ClientUser/AgentLonginOem`, { params });
  }

  //  f注册 获取验证码
  GetRegisterVerificationCode(params: { phone: string; machineVal: string; img_code_id?: string; img_code_answer?: string }) {
    const { img_code_id, img_code_answer, ...rest } = params;
    return axios.post(`${ac}/Common/GetRegisterVerificationCode?img_code_id=${img_code_id}&img_code_answer=${img_code_answer}`, rest);
  }

  // 获取权限列表
  GetUserPermission(agentUserId: string) {
    return axios.get(`${cs}/AgentPermission/GetUserPermission/${agentUserId}`);
  }
  //  保存角色行业模板数据
  apiSaveRoleIndustryTemplate(params: any) {
    return axios.post(`${qy}/SaveRoleIndustryTemplate`, params, { isIndustry: true });
  }
  // 获取全量权限模版
  apiGetAuthority0 = () => {
    return axios.get(`${qy}/Authority/GetAuthority0?smallType=12`, { params: { isIndustry: true } });
  };
  // 获取登录验证码 --->图形验证码
  GetImageCode() {
    return axios.get(`${ac}/LogOn/GetImageCode`);
  }
}

// 单列模式返回对象
let instance;
export default (() => {
  if (instance) return instance;
  instance = new Basic();
  return instance;
})();
